import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DisplayLineItem from '../common/DisplayLineItem';
var AddFeedback = /*#__PURE__*/function (_Component) {
  function AddFeedback(props) {
    var _this;
    _classCallCheck(this, AddFeedback);
    _this = _callSuper(this, AddFeedback, [props]);
    _this.state = {
      feedback: props.feedback,
      isEditing: props.index === 0
    };
    _this.handleAddFeedback = _this.handleAddFeedback.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDeleteFeedback = _this.handleDeleteFeedback.bind(_this);
    return _this;
  }
  _inherits(AddFeedback, _Component);
  return _createClass(AddFeedback, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _this$props = this.props,
        category = _this$props.category,
        id = _this$props.id,
        updateLineItemFeedback = _this$props.updateLineItemFeedback;
      updateLineItemFeedback(category, id, event.target.value);
      this.setState({
        feedback: event.target.value
      });
    }
  }, {
    key: "handleAddFeedback",
    value: function handleAddFeedback() {
      this.setState({
        isEditing: true
      });
      var _this$props2 = this.props,
        category = _this$props2.category,
        id = _this$props2.id,
        updateLineItemFeedback = _this$props2.updateLineItemFeedback;
      updateLineItemFeedback(category, id, null);
    }
  }, {
    key: "handleDeleteFeedback",
    value: function handleDeleteFeedback() {
      var _this$props3 = this.props,
        category = _this$props3.category,
        id = _this$props3.id,
        updateLineItemFeedback = _this$props3.updateLineItemFeedback;
      updateLineItemFeedback(category, id, null);
      this.setState({
        feedback: null,
        isEditing: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        index = _this$props4.index,
        id = _this$props4.id;
      var _this$state = this.state,
        isEditing = _this$state.isEditing,
        feedback = _this$state.feedback;
      return /*#__PURE__*/React.createElement("div", {
        className: "full-width with-add-feedback"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement(DisplayLineItem, _extends({}, this.props, {
        feedback: feedback,
        showFeedback: !isEditing
      })), !isEditing && /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        role: "button",
        className: "add-feedback g-row--always mt-3",
        onClick: function onClick() {
          return _this2.handleAddFeedback();
        }
      }, feedback ? 'Edit' : /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }))), isEditing && /*#__PURE__*/React.createElement("div", {
        className: "feedback-row g-row--always ".concat(index % 2 === 1 ? 'even-row' : null)
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-fill"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-5"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }), "Request edits on this line:"), /*#__PURE__*/React.createElement("textarea", {
        value: feedback,
        className: "form-control",
        placeholder: "Why the consultant should modify this line item? Type particular comments here...",
        name: "feedback",
        id: "feedback-".concat(id),
        rows: "2",
        onChange: this.handleInputChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row g-row--centered mt-5 ms-3"
      }, /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "delete-feedback",
        onClick: this.handleDeleteFeedback
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-alt mt-6"
      })))));
    }
  }]);
}(Component);
AddFeedback.propTypes = {
  index: PropTypes.number.isRequired,
  feedback: PropTypes.string,
  category: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  updateLineItemFeedback: PropTypes.func.isRequired
};
AddFeedback.defaultProps = {
  feedback: null
};
export default AddFeedback;